import { useApp }     from '../app/app_provider';
import { useContext } from 'react';
import { useEffect }  from 'react';
import { useMemo }    from 'react';
import { useState }   from 'react';
import React          from 'react';


export const SplitViewContext = React.createContext();


export default function SplitView({ children }) {
  const breakpointWidth                 = 760;
  const splitViewMQ                     = useMemo(() => window.matchMedia(`(min-width: ${breakpointWidth}px)`), []);
  const [ isSplitView, setIsSplitView ] = useState(splitViewMQ.matches);
  const app                             = useApp();

  function updateSplitView({ matches }) {
    setIsSplitView(matches);
  }

  useEffect(function addMqListener() {
    splitViewMQ.addListener(updateSplitView);
    return () => {
      splitViewMQ.removeListener(updateSplitView);
    };
  }, [ splitViewMQ ]);

  useEffect(function updateClasslist() {
    document.documentElement.classList.toggle('split-view', isSplitView);
  }, [ isSplitView ]);

  useEffect(function() {
    updatePanel({ app, isSplitView });
  }, [ app, isSplitView ]);

  useEffect(function addRouteChangeListener() {
    function onRouteChange() {
      updatePanel({ app, isSplitView });
    }

    if (app)
      app.views.main.router.on('routeChange', onRouteChange);

    return () => {
      if (app)
        app.views.main.router.off('routeChange', onRouteChange);
    };
  }, [ app, isSplitView ]);

  return (
    <SplitViewContext.Provider value={isSplitView}>
      {children}
    </SplitViewContext.Provider>
  );
}

export function useSplitView() {
  return useContext(SplitViewContext);
}

function updatePanel({ app, isSplitView }) {
  if (app) {
    const isInMobile = !isSplitView;

    if (isInMobile) {
      const { url }  = app.views.main.router.currentRoute;
      const isAtMain = url && app.views.main.router.findMatchingRoute(url);
      if (isAtMain && !isAtMain.route.onlyTab)
        setTimeout(() => app.panel.left.close());
      else
        setTimeout(() => app.panel.left.open());
    } else
      setTimeout(() => app.panel.left.open());

    app.navbar.size(app.views.main.navbarEl);
  }
}
